import {QUERY_CLIENT_MAX_AGE} from './constants.js';
import {
  checkPolicies,
  NAVIGATION_POLICY_REQUEST,
  policyQueryKeys,
} from './policies/index.js';
import {fetchTeams, teamQueryKeys} from './teams/index.js';
import type {PersistedQueryConfig, PrefetchQueryConfig} from './types.js';

export const PERSISTED_QUERIES: PersistedQueryConfig[] = [
  {
    keyPrefix: policyQueryKeys.all[0],
    maxAge: QUERY_CLIENT_MAX_AGE,
  },
  {
    keyPrefix: teamQueryKeys.all[0],
    maxAge: QUERY_CLIENT_MAX_AGE,
  },
];

export const PREFETCH_QUERIES: PrefetchQueryConfig[] = [
  {
    queryKey: policyQueryKeys.check(NAVIGATION_POLICY_REQUEST),
    queryFn: ({signal}) => checkPolicies(NAVIGATION_POLICY_REQUEST, signal),
  },
  {
    queryKey: teamQueryKeys.list(),
    queryFn: ({signal}) => fetchTeams(signal),
  },
];
